import { useState } from "react";
import { toast } from "sonner";
import { useLang } from "@/i18n";
import { Reveal, LineMask } from "@/components/Reveal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Contact = () => {
  const { t, lang } = useLang();
  const c = t.contact;
  const [form, setForm] = useState({ name: "", email: "", role: "", message: "" });
  const [sending, setSending] = useState(false);

  const set = (key) => (e) => setForm({ ...form, [key]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (sending) return;
    setSending(true);
    try {
      const res = await fetch(`${API}/leads`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ...form, lang }),
      });
      if (!res.ok) throw new Error();
      toast.success(c.success);
      setForm({ name: "", email: "", role: "", message: "" });
    } catch {
      toast.error(c.error);
    } finally {
      setSending(false);
    }
  };

  return (
    <section className="final-cta" id="contatti" aria-labelledby="cta-title" data-testid="contact-section">
      <div className="final-cta-bg" aria-hidden="true"></div>
      <div className="shell contact-grid">
        <div>
          <Reveal><p className="eyebrow">{c.eyebrow}</p></Reveal>
          <h2 id="cta-title">
            <LineMask delay={0.1}>{c.titleA}</LineMask>
            <LineMask delay={0.22}><em style={{ color: "var(--lime)", fontStyle: "normal" }}>{c.titleB}</em></LineMask>
          </h2>
          <Reveal delay={0.25}>
            <p className="cta-sub">{c.sub}</p>
            <p className="cta-sub" style={{ marginTop: 0 }}>
              {c.emailLabel}{" "}
              <a className="cta-email" href="mailto:info@innoversegroup.it" data-testid="contact-email-link">
                info@innoversegroup.it ↗
              </a>
            </p>
          </Reveal>
        </div>

        <Reveal delay={0.2}>
          <form className="form-card" onSubmit={submit} data-testid="contact-form">
            <h3>{c.formTitle}</h3>
            <p>{c.formSub}</p>
            <div className="field">
              <label htmlFor="lead-name">{c.name}</label>
              <input id="lead-name" required value={form.name} onChange={set("name")} placeholder={c.namePh} data-testid="contact-name-input" />
            </div>
            <div className="field">
              <label htmlFor="lead-email">{c.email}</label>
              <input id="lead-email" type="email" required value={form.email} onChange={set("email")} placeholder={c.emailPh} data-testid="contact-email-input" />
            </div>
            <div className="field">
              <label htmlFor="lead-role">{c.role}</label>
              <select id="lead-role" required value={form.role} onChange={set("role")} data-testid="contact-role-select">
                <option value="" disabled>—</option>
                {c.roles.map((r) => <option key={r} value={r}>{r}</option>)}
              </select>
            </div>
            <div className="field">
              <label htmlFor="lead-message">{c.message}</label>
              <textarea id="lead-message" value={form.message} onChange={set("message")} placeholder={c.messagePh} data-testid="contact-message-input" />
            </div>
            <button className="button button-primary form-submit" type="submit" disabled={sending} data-testid="contact-submit-button">
              {sending ? c.sending : c.submit} <span aria-hidden="true">↗</span>
            </button>
          </form>
        </Reveal>
      </div>
    </section>
  );
};

export default Contact;
